<template lang="html">
    <v-container v-if="filters && filters.length" fluid class="pa-0">

        <filter-chip
                v-for="(filter, i) in filters" :key="i"
                :filter="filter"
        >
        </filter-chip>

    </v-container>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {SEARCH_NS} from "../../../store/modules/search/constants";
    import FilterChip from "@/components/home/filter/FilterChip";

    export default {
        components: {FilterChip},
        computed: {
            ...mapGetters(SEARCH_NS, [
                'filters'
            ])
        }
    }
</script>